<eui-toolbar-item>
    <ng-content select="eui-search"></ng-content>
</eui-toolbar-item>
